import React from "react";
import { withFormsy } from "formsy-react";
import { FormGroup, FormFeedback, Label } from "reactstrap";
import Select from "react-select";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";
//import DailyMealPlan from "../../Admin/MealPlan/DailyMealPlan";
export class MySelectComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            stepIndex: 0,

            steps: [
                {
                    target: tourMessages.instructorInterests.target,
                    content: (
                        <div>
                            <p>{tourMessages.instructorInterests.title}</p>
                        </div>
                    ),
                    placement: "left",
                    locale: { skip: "SKIP", close: "Next" },
                },
                tourMessages.default,
            ],
        };
    }
    onClickSelect = () => {
        this.props.onClick();
    };
    changeValue = (selectedOption) => {
        if (this.props.onChange) {
            if (this.props.id >= 0) {
                this.props.onChange(selectedOption, this.props.id);
            } else {
                //check if it is updating for meal plan
                if (this.props.day >= 0) {
                    this.props.onChange(selectedOption, this.props.day, this.props.mealTypeCode);
                } else {
                    this.props.onChange(selectedOption);
                }
            }
        }
        let value;
        if (selectedOption && ((Array.isArray(selectedOption) && selectedOption.length) || !Array.isArray(selectedOption))) {
            value = selectedOption;
        }
        this.setState({ selectedOption: value });
        this.props.setValue(value);
        if (this.props.mealModulus) {
            this.props.addFoodItemToArry(selectedOption, this.props.day, this.props.mealTypeCode, this.props.isRoaster, this.props.index);
        }
    };
    //================TOUR GUIDE SECTION========================//
    handleJoyrideCallback = (data) => {
        const { action, index, status, type } = data;

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
        } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
        } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            if ([STATUS.SKIPPED].includes(status)) {
                this.setState({ run: false });
            } else {
                this.props.setTitleJoyRide();
            }
        }
    };
    render() {
        const errorMessage = this.props.getErrorMessage();
        const { options, validating, valueKey, labelKey, disabled, showRequired, showError, name, getValue, title, isPristine, isRequired, hasValue, isMulti, isClearable, joyRideRun } = this.props;
        const { steps, stepIndex } = this.state;
        const hasError = !isPristine() && (showError() || (isRequired && !hasValue()));
        return (
            <div>
                <Joyride
                    steps={steps}
                    scrollToFirstStep
                    showProgress
                    showSkipButton
                    styles={{
                        options: {
                            width: 300,
                            height: 60,
                            zIndex: 1000,
                        },
                    }}
                    callback={this.handleJoyrideCallback}
                    run={joyRideRun}
                    stepIndex={stepIndex}
                />
                <FormGroup>
                    <Label className={isRequired && "required"} htmlFor={name}>
                        {title}
                    </Label>
                    <Select
                        value={getValue() || ""}
                        defaultValue={null}
                        className={hasError ? "is-invalid" : joyRideRun ? "joyride12" : ""}
                        options={options}
                        isDisabled={validating ? true : false || disabled}
                        name={name}
                        isMulti={isMulti}
                        isClearable={isClearable}
                        onChange={this.changeValue}
                        onClick={this.onClickSelect}
                        getOptionLabel={(option) => option[labelKey]}
                        getOptionValue={(option) => option[valueKey]}
                    />
                    {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
                    {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
                </FormGroup>
            </div>
        );
    }
}

const FormSelect = withFormsy(MySelectComponent);

export { FormSelect as MySelect };
